import React, { FC, ReactNode, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Box } from '@material-ui/core';

import { AuthContext, AuthStatus } from 'src/contexts/authContext';
import { Theme } from 'src/theme';
import { API } from 'aws-amplify';

import UiNavLeft from './UiNavLeft';
import UiHeader from './UiHeader';
import { useDispatch } from 'react-redux';
import {
  editUserCompany,
  editUserName,
  editUserEmail,
  editUserGrade
} from 'src/store/modules/client';
import PricingPopup from 'src/components/Popup/PricingPopup';
import { RootState, useSelector } from 'src/store';
import usePopup from 'src/hooks/usePopup';
import { useLocation } from 'react-router';

interface Props {
  header: any;
  onClick: (e: any) => void;
  children?: ReactNode;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100vw',
    height: '100%',
    minWidth: 1200,

    display: 'flex',
    backgroundColor: '#f5f5f5'
  },
  container: {
    // width: `calc(100% - 70px)`,
    height: '100%',
    display: 'flex',
    flexDirection: 'row'
  }
}));

const DashboardLayout: FC<Props> = ({ children }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const authContext = useContext(AuthContext);

  useEffect(() => {
    async function onLoad() {
      try {
        const user = await authContext.getAttributes();
        for (let i = 0; i < user.length; i++) {
          if (user[i]['Name'] === 'custom:Company') {
            dispatch(editUserCompany(user[i]['Value']));
            break;
          }
        }
        for (let i = 0; i < user.length; i++) {
          if (user[i]['Name'] === 'custom:Name') {
            dispatch(editUserName(user[i]['Value']));
            break;
          }
        }
        for (let i = 0; i < user.length; i++) {
          if (user[i]['Name'] === 'email') {
            dispatch(editUserEmail(user[i]['Value']));
            break;
          }
        }
      } catch (err) {}

      try {
        const result = await API.get(
          'iam-editor',
          '/subscription/subscription-info',
          ''
        );

        if (
          result.subscriptionExpireDate &&
          result.subscriptionExpireDate - Date.now() > 0
        ) {
          dispatch(editUserGrade('plus'));
        } else if (
          result.freeTrialExpireDate &&
          result.freeTrialExpireDate - Date.now() > 0
        ) {
          dispatch(editUserGrade('freeTrial'));
        } else {
          dispatch(editUserGrade('basic'));
        }
      } catch (err) {}
    }

    if (authContext?.authStatus === AuthStatus.SignedIn) onLoad();
  }, []);

  const [isContentVisible, setIsContentVisible] = useState(false);

  return (
    <>
      <Box className={classes.root}>
        <UiHeader visible={isContentVisible} />
        <UiNavLeft
          visible={isContentVisible}
          setVisible={setIsContentVisible}
        />
        <div className={classes.container}>{children}</div>
      </Box>
    </>
  );
};

export default DashboardLayout;
